import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useAnalytics from '../../../lib/hooks/useAnalytics';
import { ANALYTICS_EVENTS, BRANDS } from '../../constants';
import Brand from '../../prop-types/brand';
import DataGrid from '../DataGrid';

export default function MiniBrandList({ activeBrand, showHeader }) {
  const { t } = useTranslation('brand');
  const analytics = useAnalytics();

  const handleItemClick = useCallback(({ displayText: brandName }) => {
    analytics.tagEvent({
      name: ANALYTICS_EVENTS.BRAND_PAGE_LINK_CLICKED,
      attributes: { Brand: brandName },
    });
  }, [analytics]);

  const brandItems = BRANDS.map(brand => ({
    key: brand.brandId,
    displayText: brand.name,
    url: `/brands/${brand.uri}`,
    isActive: activeBrand.name === brand.name,
  }));

  return (
    <DataGrid
      header={showHeader ? t('findGasByBrand', { ns: 'brand' }) : null}
      items={brandItems}
      onItemClick={handleItemClick}
      mobile={6}
    />
  );
}

MiniBrandList.propTypes = {
  activeBrand: Brand,
  showHeader: PropTypes.bool,
};

MiniBrandList.defaultProps = {
  activeBrand: { name: '' },
  showHeader: false,
};
